package app.nestbridge.feature.main.ui

import androidx.compose.foundation.layout.padding
import androidx.compose.material3.CenterAlignedTopAppBar
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.NavigationBar
import androidx.compose.material3.NavigationBarItem
import androidx.compose.material3.NavigationBarItemDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.karawek.core.ui.theme.CoreTheme
import com.karawek.core.ui.theme.CoreTypography
import app.nestbridge.feature.main.screen.MainTab

@OptIn(ExperimentalMaterial3Api::class)
interface PlatformMainShellBar {
    @Composable
    fun TopBar(
        title: String,
        onProfileClick: () -> Unit,
        modifier: Modifier = Modifier,
        profilePictureUrl: String? = null,
        userName: String? = null,
    ) {
        // Material-style (Android/JVM/Web/Desktop).
        CenterAlignedTopAppBar(
            modifier = modifier,
            title = {
                Text(
                    text = title,
                    style = CoreTypography.body,
                    color = CoreTheme.colors.textPrimary,
                )
            },
            actions = {
                ProfileAvatarButton(
                    onClick = onProfileClick,
                    profilePictureUrl = profilePictureUrl,
                    userName = userName,
                    modifier = Modifier.padding(end = 6.dp),
                )
            },
        )
    }

    @Composable
    fun BottomBar(
        selectedTab: MainTab,
        onTabSelected: (MainTab) -> Unit,
        modifier: Modifier = Modifier,
    ) {
        NavigationBar(
            modifier = modifier,
        ) {
            MainTab.entries.forEach { tab ->
                NavigationBarItem(
                    selected = selectedTab == tab,
                    icon = { Icon(imageVector = tab.icon(), contentDescription = tab.label()) },
                    label = { Text(text = tab.label()) },
                    colors = NavigationBarItemDefaults.colors(
                        selectedTextColor = CoreTheme.colors.infoAccent,
                        unselectedTextColor = CoreTheme.colors.textMuted,
                    ),
                    onClick = { onTabSelected(tab) },
                )
            }
        }
    }
}

@Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")
expect class MainShellBar(): PlatformMainShellBar
